import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAppBridge, useRoutePropagation } from '@shopify/app-bridge-react';
import { Redirect } from '@shopify/app-bridge/actions';

const AppBridge = ({ children }) => {
  const app = useAppBridge();
  const router = useRouter();
  useRoutePropagation(router.asPath);

  useEffect(() => {
    // init app for referencing it outside react components
    // you can use react context for this purpose too
    // const app = React.useContext(AppBridgeContext);
    window.assortion = app;

    // // remove authentication query params
    // const { hmac } = router.query;
    // if (hmac) {
    //   router.push({
    //     pathname: router.pathname,
    //     query: {},
    //   });
    // }

    // // remove authentication query params
    // const { host } = router.query;
    // if (host) {
    //   const basePath = router.asPath.split('?')[0] || router.asPath;

    //   // const query = router.query;

    //   // Object.keys(query).map(function (k) {
    //   //   if (router.pathname.includes(`[${k}]`)) {
    //   //     delete query[k];
    //   //   }
    //   // });

    //   // const url = { pathname: router.pathname, query };
    //   // const urlAs = { pathname: basePath, query };

    //   // router.push(url, urlAs);
    //   // console.log('basePath:', router.asPath);
    //   // console.log('query params:', router);

    //   console.log('asPath: ', router.asPath);
    //   console.log('basePath: ', basePath);

    //   router.push({ pathname: basePath, query: {} });
    // }

    // subscribe to appBridge changes - captures appBridge urls and sends them to Next.js router
    const unsubscribe = app.subscribe(Redirect.Action.APP, ({ path }) => {
      if (router.asPath !== path) {
        if (path.includes('/api/shopify/auth')) {
          router.push('/');
          return;
        }
        router.push(path);
      }
    });

    return unsubscribe;
  }, [app, router]);

  if (!router.isReady) return null;

  return children;
};

export default AppBridge;
